import { Navigate } from "react-router-dom";

// ==============================|| AUTH GUARD ||============================== //

import { useJWT } from "../contexts/auth";

const AuthGuard = ({ children }: any) => {
  const { isLoggedIn, loading } = useJWT();

  return loading ? null : isLoggedIn ? children : <Navigate to="/" />;
};

export default AuthGuard;
